"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
const SubscriptionCardLicenseInfo_1 = require("../../molecules/SubscriptionCardLicenseInfo/SubscriptionCardLicenseInfo");
const SubscriptionCardPricingInfo_1 = require("../../molecules/SubscriptionCardPricingInfo/SubscriptionCardPricingInfo");
function SubscriptionCard({ license, isRecommended, isSelected, onClick, isMobile, role = 'button', tabIndex, }) {
    const { t } = (0, i18n_1.useTranslation)();
    const isStudentLicense = (license === null || license === void 0 ? void 0 : license.type) === bridge_schema_1.LicenseType.StudentPlus;
    const isValidLicense = license.product !== undefined;
    const studentTab = isRecommended ? 'recommended' : 'popular';
    const professionalTab = isRecommended ? 'recommended' : 'presentation';
    const selectedTab = t(i18n_1.Strings.userOnboarding.subsSheet.buy[isStudentLicense ? studentTab : professionalTab]);
    return ((0, jsx_runtime_1.jsxs)(Container, { isSelected: isSelected && isValidLicense, onClick: onClick, role: role, tabIndex: tabIndex, onKeyDown: e => {
            if (e.key === 'Enter') {
                onClick();
            }
        }, "data-e2e": 'SubscriptionCard_Container', children: [isSelected && isValidLicense && ((0, jsx_runtime_1.jsx)(RecommendedTab, { isSelected: isSelected, isMobile: isMobile, "data-e2e": 'SubscriptionCard_RecommendedTab', children: selectedTab })), (0, jsx_runtime_1.jsxs)(MainCardContent, { isSelected: isSelected && isValidLicense, isMobile: isMobile, "data-e2e": 'SubscriptionCard_MainCardContent', children: [(0, jsx_runtime_1.jsx)(SubscriptionCardLicenseInfo_1.SubscriptionCardLicenseInfo, { isMobile: isMobile, license: license, "data-e2e": 'SubscriptionCard_SubscriptionCardLicenseInfo' }), (0, jsx_runtime_1.jsx)(SubscriptionCardPricingInfo_1.SubscriptionCardPricingInfo, { isSelected: isSelected, isMobile: isMobile, isValidLicense: isValidLicense, license: license, "data-e2e": 'SubscriptionCard_SubscriptionCardPricingInfo' })] })] }));
}
exports.SubscriptionCard = SubscriptionCard;
const Container = styled_components_1.default.div `
  gap: 0;

  ${({ isSelected }) => isSelected &&
    `
    background-color: #47CFCB;
    border-radius: 8px;
  `}

  &:focus-visible {
    outline: 2px solid #47cfcb;
    outline-offset: 6px;
  }
`;
const RecommendedTab = styled_components_1.default.div `
  width: 256px;
  height: 42px;

  display: flex;
  justify-content: center;
  align-items: center;

  text-transform: uppercase;
  font-size: 16px;
  color: #11151c;

  border-radius: 8px 8px 0 0;
  background-color: #47cfcb;

  ${({ isMobile }) => isMobile && `width: 310px;`}

  ${({ isSelected }) => !isSelected &&
    `
      background-color: transparent;
      color: transparent;
    `}
`;
const MainCardContent = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-start;

  width: 310px;
  min-height: 140px;
  max-height: auto;
  padding: 16px 0px;
  gap: 8px;

  border-radius: 8px;
  box-sizing: border-box;
  background-color: white;

  //For tablets and larger screens, use vertical card.
  ${({ isMobile }) => !isMobile
    ? `
      width: 256px;
      height: 350px;
      padding: 24px 0px;
      gap: 18px;

      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

    `
    : `border: none;`};

  ${({ isSelected }) => isSelected
    ? `
      border: solid 4px #47CFCB;
      border-radius: 0 0 8px 8px;

    `
    : `border: none;`};
`;
